<template>
  <div class="content">
    <v-flex>
      <div class="description">
        <div class="user" v-if="isAuth">
          <div class="welcome mb-4">
            <h4>Bem vindo(a) a</h4>
            <h3>Nutris</h3>
          </div>
          <div style="position: relative;">
            <img
              :src="profile.photo || 'https://img.icons8.com/color/48/000000/madagaskar.png'"
              :alt="profile.name"
            />
            <!-- <div class="icon-ab">
              <v-icon color="#000000" small fab dark>mdi-pencil</v-icon>
            </div> -->
          </div>
          <div class="user-name mb-6">
            <h4>{{profile.name || "Nutri"}} :)</h4>
          </div>
          <v-btn
            color="#006064"
            class="white--text"
            @click="getDiets.length > 0 ? $router.replace('calcular-dieta') : $router.replace('gerenciar-dietas')"
          >{{getDiets.length > 0 ? 'Bora calcular' : 'Cadastrar minha primeira dieta'}}</v-btn>
        </div>
        <div v-else>
          <h2 class="display-1">Cálculos de dietas parenteral e enteral</h2>
          <p>Faça seus cálculos bem rapidinho ;)</p>
        </div>
      </div>
      <v-btn
        v-if="!isAuth"
        color="#006064"
        class="white--text btn__google"
        @click="signInWithGoogle()"
      >Login com Google</v-btn>
      <v-btn
        v-if="!isAuth"
        color="#4267b2"
        class="white--text btn__facebook"
        @click="signInWithFacebook()"
      >Login com Facebook</v-btn>
    </v-flex>
  </div>
</template>

<script>
import firebase from "firebase";
import { mapGetters } from "vuex";

export default {
  name: "appHome",
  computed: {
    ...mapGetters({
      isAuth: "auth/userId",
      profile: "auth/profile",
      getDiets: "dietsBase/getDiets"
    })
  },
  methods: {
    signInWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(() => {
          let user = firebase.auth().currentUser;
          this.$store.commit("auth/setUser", user);
          this.$router.replace("/");
        })
        .catch(error => console.log("🤕 " + error.message));
    },
    signInWithFacebook() {
      const provider = new firebase.auth.FacebookAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          let token = result.credential.accessToken;
          let user = firebase.auth().currentUser;
          this.$store.commit("auth/setUser", user);
          this.$router.replace("/");
        })
        .catch(error => {
          console.log("🤕 " + error.message);
        });
    }
  }
};
</script>

<style scoped>
content {
  color: #006064;
}

.description {
  margin-bottom: 100px;
}

.user {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.user img {
  max-width: 150px;
  border-radius: 50%;
  margin-bottom: 20px;
}

.icon-ab {
  position: absolute;
  bottom: 29px;
  opacity: 0.5;
  background: white;
  border-radius: 50%;
  right: 41%;
  width: 25px;
  height: 25px;
}

.icon-ab:hover {
  opacity: 0.85;
}
.user-name {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
}

.user .welcome {
  font-size: 1.7em;
}

.user h4 {
  font-size: 1.5em;
}

.user h3 {
  font-family: "Lobster", cursive;
  margin: 0 7px;
}

.display-1 {
  margin: 100px 0 50px;
  font-weight: bolder !important;
}

.btn__facebook,
.btn__google {
  cursor: pointer !important;
  margin: 5px 5px;
}
</style>
